import produce from 'immer';
import {
  GET_HOMEPAGE_BANNER_GROUP_START,
  GET_HOMEPAGE_BANNER_GROUP_SUCCESS,
  GET_HOMEPAGE_BANNER_GROUP_FAILED,
  SAVE_BANNER_SLIDE_START,
  SAVE_BANNER_SLIDE_SUCCESS,
  SAVE_BANNER_SLIDE_FAILED,
  DELETE_BANNER_SLIDE_START,
  DELETE_BANNER_SLIDE_SUCCESS,
  DELETE_BANNER_SLIDE_FAILED,
  ADD_NEW_BANNER_SLIDE_START,
  ADD_NEW_BANNER_SLIDE_SUCCESS,
  ADD_NEW_BANNER_SLIDE_FAILED
} from '../actions/banner_manager';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  homepageBannerGroup: {},
  homepageSlidesActive: [],
  homepageSlidesDraft: [],
  loadingHomepageBannerGroups: false,
  loadingSaveSlide: false,
  loadingDeleteSlide: false,
  loadingAddNewSlide: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_HOMEPAGE_BANNER_GROUP_START: {
      state.loadingHomepageBannerGroups = true;
      break;
    }
    case GET_HOMEPAGE_BANNER_GROUP_SUCCESS: {
      const {data} = action;

      // eslint-disable-next-line prefer-destructuring
      state.homepageBannerGroup = data[0];
      state.homepageSlidesActive = data[0].slides.filter((slide) => slide.is_active == 1);
      state.homepageSlidesDraft = data[0].slides.filter((slide) => slide.is_active == 0);
      state.loadingHomepageBannerGroups = false;

      state.homepageSlidesActive.map((slide) => {
        const slideEndDate = Date.parse(slide.slide_enddate);
        const currentDate = Date.now();

        if (slide.slide_enddate !== '' && slideEndDate < currentDate) {
          slide.is_active = '0';
          state.homepageSlidesActive = data[0].slides.filter((slide) => slide.is_active == 1);
          state.homepageSlidesDraft = data[0].slides.filter((slide) => slide.is_active == 0);
        }
      });

      break;
    }
    case GET_HOMEPAGE_BANNER_GROUP_FAILED: {
      state.loadingHomepageBannerGroups = false;
      break;
    }
    case SAVE_BANNER_SLIDE_START: {
      state.loadingSaveSlide = true;
      break;
    }
    case SAVE_BANNER_SLIDE_SUCCESS: {
      const {data} = action;

      state.homepageBannerGroup.slides = state.homepageBannerGroup.slides.map((slide) => slide.slide_id === data.slide_id ? data : slide);
      state.homepageSlidesActive = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 1);
      state.homepageSlidesDraft = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 0);
      state.loadingSaveSlide = false;

      break;
    }
    case SAVE_BANNER_SLIDE_FAILED: {
      state.loadingSaveSlide = false;
      break;
    }
    case DELETE_BANNER_SLIDE_START: {
      state.loadingDeleteSlide = true;
      break;
    }
    case DELETE_BANNER_SLIDE_SUCCESS: {
      const {id} = action;

      state.homepageBannerGroup.slides = state.homepageBannerGroup.slides.filter((slide) => slide.slide_id != id);
      state.homepageSlidesActive = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 1);
      state.homepageSlidesDraft = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 0);
      state.loadingDeleteSlide = false;

      break;
    }
    case DELETE_BANNER_SLIDE_FAILED: {
      state.loadingDeleteSlide = false;
      break;
    }
    case ADD_NEW_BANNER_SLIDE_START: {
      state.loadingAddNewSlide = true;
      break;
    }
    case ADD_NEW_BANNER_SLIDE_SUCCESS: {
      const {data} = action;

      state.homepageBannerGroup.slides = [...state.homepageBannerGroup.slides, data];
      state.homepageSlidesActive = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 1);
      state.homepageSlidesDraft = state.homepageBannerGroup.slides.filter((slide) => slide.is_active == 0);
      state.loadingAddNewSlide = false;

      break;
    }
    case ADD_NEW_BANNER_SLIDE_FAILED: {
      state.loadingAddNewSlide = false;
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.homepageBannerGroup = {};

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
